import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          padding: 4,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          boxShadow: '0',
        }}
      >
        <CircularProgress 
          size={60} 
          thickness={4}
          sx={{
            color: '#0051C3',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }} 
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#333',
            fontWeight: 500,
            fontFamily: 'Roboto, sans-serif',
            marginTop: 2,
          }}
        >
          Loading PolicyTrackr...
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingSpinner;
